import { Link } from 'react-router-dom';

import Flex from 'shared/layout/Flex';
import back from 'shared/static/images/back.svg';

import Text from './Text';

export default function Back({ state, to, text, disabled = false }) {
  const el = (
    <Flex alignItems="center">
      <img src={back} style={{ marginRight: 20, height: 16, width: 10 }} alt="Go back" />
      <Text type="openings">{text}</Text>
    </Flex>
  );
  if (disabled) return el;
  return (
    <Link to={to} state={state}>
      {el}
    </Link>
  );
}
